import { create } from 'zustand';
import { tokenStorage, type AuthTokens } from '@shared/api';
import type { SessionUser } from './types';

interface SessionState {
  user: SessionUser | null;
  status: 'unknown' | 'authenticated' | 'anonymous';
  setSession: (tokens: AuthTokens, user?: SessionUser | null) => void;
  setUser: (user: SessionUser | null) => void;
  hydrate: () => void;
  clear: () => void;
}

export const useSessionStore = create<SessionState>()((set) => ({
  user: null,
  status: 'unknown',
  setSession: (tokens, user) => {
    tokenStorage.set(tokens);
    set((prev) => ({
      user: user ?? prev.user,
      status: 'authenticated',
    }));
  },
  setUser: (user) => set({ user }),
  hydrate: () => {
    tokenStorage.hydrateFromStorage();
    const access = tokenStorage.getAccess();
    set({ status: access ? 'authenticated' : 'anonymous' });
  },
  clear: () => {
    tokenStorage.clear();
    set({ user: null, status: 'anonymous' });
  },
}));

export const sessionSelectors = {
  isAuthenticated: (s: SessionState) => s.status === 'authenticated',
  user: (s: SessionState) => s.user,
  status: (s: SessionState) => s.status,
};
